import type { Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    quote: {
      en: 'IG Foundation Systems saved our home from serious structural damage. They found settling two other contractors missed, explained everything clearly, and the pricing was fair.',
      es: 'IG Foundation Systems salvó nuestra casa de un daño estructural serio. Encontraron un asentamiento que otros dos contratistas pasaron por alto, explicaron todo con claridad y el precio fue justo.',
    },
    name: 'John D.',
    location: 'Seattle, WA',
    initials: 'JD',
    service: { en: 'Foundation Repair', es: 'Reparación de Cimientos' },
  },
  {
    id: 't2',
    quote: {
      en: 'Outstanding crawl space work. The team was professional, punctual, and left the space cleaner than the rest of the house. No more musty smell upstairs.',
      es: 'Trabajo excepcional en el crawl space. El equipo fue profesional, puntual y dejó el espacio más limpio que el resto de la casa. Ya no hay olor a humedad arriba.',
    },
    name: 'Maria L.',
    location: 'Tacoma, WA',
    initials: 'ML',
    service: { en: 'Crawl Space Encapsulation', es: 'Encapsulado de Crawl Space' },
  },
  {
    id: 't3',
    quote: {
      en: 'Best foundation repair company in Washington. Free inspection, honest report, and they finished a day early. We could not be happier with the quality and service.',
      es: 'La mejor empresa de reparación de cimientos en Washington. Inspección gratis, informe honesto y terminaron un día antes. No podríamos estar más contentos.',
    },
    name: 'David R.',
    location: 'Olympia, WA',
    initials: 'DR',
    service: { en: 'Basement Waterproofing', es: 'Impermeabilización de Sótano' },
  },
  {
    id: 't4',
    quote: {
      en: 'The bilingual team made communication easy from the first call. Excellent work on our floor joists and very competitive pricing.',
      es: 'El equipo bilingüe hizo que la comunicación fuera fácil desde la primera llamada. Excelente trabajo en nuestras viguetas y precios muy competitivos.',
    },
    name: 'Carlos M.',
    location: 'Federal Way, WA',
    initials: 'CM',
    service: { en: 'Floor Joist Reinforcement', es: 'Refuerzo de Viguetas' },
  },
  {
    id: 't5',
    quote: {
      en: 'Our heating bill dropped noticeably after the insulation upgrade. Clean, careful crew and a warranty in writing. Highly recommend them in Mason County.',
      es: 'Nuestra factura de calefacción bajó notablemente tras la mejora de aislamiento. Equipo limpio y cuidadoso, con garantía por escrito. Los recomiendo en el condado de Mason.',
    },
    name: 'Sarah T.',
    location: 'Shelton, WA',
    initials: 'ST',
    service: { en: 'Insulation Installation', es: 'Instalación de Aislamiento' },
  },
]
